import { Box } from "@chakra-ui/core";
import React from "react";

import type { IconName } from "./ImportedIcons";
import { allIcons } from "./ImportedIcons"; // GENERATED AUTOMATICALLY

// Props interface
interface IconProps {
	[key: string]: any;
	className?: string;
	color?: string;
	height?: number | string;
	icon: IconName;
	iconClassName?: string;
	isDanger?: boolean;
	size?: number | string;
	strokeWidth?: number;
	style?: React.CSSProperties;
	sx?: any;
	width?: number | string;
	onClick?: () => void;
}

// This is REQUIRED for Chakra v2 due to Box not supporting sx=
interface BoxWithSxProps extends React.ComponentProps<typeof Box> {
	sx?: Record<string, any>;
}

export const iconName = (name: IconName) => name;

export const getIconName = (name: string, fallbackIcon?: IconName) => {
	const result = name as IconName;

	if (!name || !allIcons[name]) {
		return fallbackIcon ?? result;
	}

	return result;
};

export const getFileTypeIconName = (fileType: string): IconName => {
	return getIconName(fileType, "file");
};

export const Icon: React.FC<IconProps> = ({
	icon,
	sx,
	size = "auto",
	width,
	height,
	strokeWidth,
	className = "",
	iconClassName = "",
	color,
	isDanger = false,
	...props
}) => {
	const pixelMe = (val: string | number): string =>
		val === "auto" ||
		(typeof val === "string" && (val.includes("%") || val.includes("px")))
			? String(val)
			: `${val}px`;

	const svgWidth = width !== undefined ? pixelMe(width) : pixelMe(size);
	const svgHeight = height !== undefined ? pixelMe(height) : pixelMe(size);

	let finalSx = sx;
	if (color) {
		finalSx = {
			color: color,
			...sx,
		};
	}

	switch (icon) {
		case "arrow-down":
			finalSx = {
				transform: "rotate(180deg)",
				...finalSx,
			};
			break;
		default:
			break;
	}

	const renderIcon = (iconName: IconName): React.ReactElement | string => {
		if (allIcons.hasOwnProperty(iconName)) {
			return allIcons[iconName]({
				...props,
				className: iconClassName,
			} as React.SVGProps<SVGSVGElement>);
		}
		return "";
	};

	return (
		<Box
			{...({
				sx: {
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					"& >svg": {
						width: svgWidth,
						height: svgHeight,
						maxWidth: "100%",
						maxHeight: "100%",
						color: "red",
						"& path": {
							strokeWidth,
							stroke: "#D92D20",
						},
					},
					...finalSx,
				},
				className: `${className} ${isDanger ? "svg-danger" : ""}`,
				...props,
			} as BoxWithSxProps)}
		>
			{renderIcon(icon)}
		</Box>
	);
};
